export const boxShadow = {
  thin: 'inset 0 0 0 0.0625rem',
  thick: 'inset 0 0 0 0.125rem',
  thicker: 'inset 0 0 0 0.25rem',
}
export const shadowColor = {
  5: 'rgb(0 0 0 / 0.05)',
  10: 'rgb(0 0 0 / 0.1)',
  25: 'rgb(0 0 0 / 0.25)',
}
export const shadow = {
  sm: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
  md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
  lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
  xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
}
